
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// Use HashRouter for better compatibility with various publishing environments
// This helps ensure routes work correctly when deployed to app stores
const Router = window.location.hostname === 'localhost' ? BrowserRouter : HashRouter;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// Register service worker for production and development
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    try {
      // Use a dynamic import for the service worker
      import('workbox-window/Workbox').then(({ Workbox }) => {
        const wb = new Workbox('/service-worker.js');
        
        wb.addEventListener('installed', (event) => {
          if (event.isUpdate) {
            if (confirm('New content is available. Reload to update?')) {
              window.location.reload();
            }
          } else {
            console.log('App is ready for offline use');
          }
        });
        
        wb.addEventListener('activated', () => {
          console.log('Service worker activated');
        });
        
        wb.addEventListener('waiting', () => {
          // A new service worker is waiting to be activated
          console.log('New service worker waiting to be activated');
        });
        
        wb.register().catch(error => {
          console.error('Service worker registration failed:', error);
        });
      });
    } catch (error) {
      console.error('Error during service worker registration:', error);
    }
  });
}
